/**
 * Vehicle Real-time Plugin
 * Automatically manages real-time vehicle updates when VMS is enabled
 */

export default defineNuxtPlugin({
  name: 'vehicle-realtime',
  async setup() {
    // Only run on client side
    if (!process.client) return

    // Wait for Pinia to be ready
    await nextTick()
    
    // Additional wait to ensure Pinia is fully initialized
    let retries = 0
    while (retries < 10) {
      try {
        // Test if stores are available
        const { useVehiclesStore } = await import('~/stores/vehicles')
        const testStore = useVehiclesStore()
        if (testStore) break
      } catch (error) {
        // Pinia not ready yet, wait a bit more
        await new Promise(resolve => setTimeout(resolve, 100))
        retries++
      }
    }

    const runtimeConfig = useRuntimeConfig()
    const route = useRoute()
    
    // Check if VMS is enabled
    const isVMSEnabled = runtimeConfig.public.features?.vms === true
    
    if (!isVMSEnabled) return

    console.log('[VMS Plugin] Vehicle real-time plugin initialized')

  // Auto-enable real-time on vehicle-related pages
  const vehiclePages = [
    '/cars-for-sale',
    '/vehicles',
    '/vms',
    '/vehicle-for-sale'
  ]

  const isVehiclePage = vehiclePages.some(page => 
    route.path.startsWith(page)
  )

  if (isVehiclePage) {
    console.log('[VMS Plugin] Vehicle page detected, enabling real-time updates')
    
    // Small delay to ensure stores are initialized
    setTimeout(async () => {
      try {
        // Dynamically import the composable to avoid SSR issues
        const { useVehicleRealtime } = await import('~/composables/useVehicleRealtime')
        const { useVehiclesStore } = await import('~/stores/vehicles')
        
        const vehiclesStore = useVehiclesStore()
        const { subscribeToVehicleUpdates } = useVehicleRealtime()
        subscribeToVehicleUpdates()
      } catch (error) {
        console.warn('[VMS Plugin] Could not initialize real-time updates:', error)
      }
    }, 1000)
  }
  }
})